<button id="WF_View_Instances" class="btn btn-sm btn-outline-dark py-0 my-1 px-0 border-0" ><i class="fas fa-clone mx-2" aria-hidden="true"></i></button>